/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
export var WaitlistOptions;
(function (WaitlistOptions) {
    WaitlistOptions["No"] = "100000001";
    WaitlistOptions["Yes"] = "100000002";
})(WaitlistOptions || (WaitlistOptions = {}));
export var EventFormSubmissionTypes;
(function (EventFormSubmissionTypes) {
    EventFormSubmissionTypes["eventRegistrationCancellation"] = "eventRegistrationCancellation";
    EventFormSubmissionTypes["sessionRegistrationCancellation"] = "sessionRegistrationCancellation";
    EventFormSubmissionTypes["registration"] = "registration";
    EventFormSubmissionTypes["waitlist"] = "waitlist";
})(EventFormSubmissionTypes || (EventFormSubmissionTypes = {}));
